// Dropdown v2 — substitui visualmente todo <select data-cda-select> por um botão +
// lista estilizada, no padrão "select-only combobox" do WAI-ARIA.
//
// O <select> nativo continua no DOM (escondido): é ele que vai no submit do form e
// que dispara o evento `change`, então handlers existentes seguem funcionando.
//
// Uso no ERB:
//   select_tag :campo, options_for_select([['Livros', 'books', { 'data-icon' => 'book' }], ...]),
//              data: { cda_select: true }        # variante padrão (campo de formulário)
//              data: { cda_select: 'chip' }      # chip (ex.: escopo da busca)
//              data: { cda_select: 'night' }     # sobre fundo escuro (ex.: top bar)
//
// `data-icon` na <option> usa os ícones do sprite (NewStyleHelper::CDA_ICONS).
// Se as opções mudarem via JS, chame window.cdaSelect.refresh(select).

var CHEVRON_PATH = '<path d="m6 9 6 6 6-6"/>';
var CHECK_PATH = '<path d="M20 6 9 17l-5-5"/>';
var TYPEAHEAD_DELAY = 500;

var uid = 0;
var openState = null;

function svg(className, inner) {
  var el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  el.setAttribute('class', className);
  el.setAttribute('viewBox', '0 0 24 24');
  el.setAttribute('aria-hidden', 'true');
  el.setAttribute('focusable', 'false');
  el.innerHTML = inner;
  return el;
}

function iconFor(option) {
  var name = option && option.getAttribute('data-icon');
  if (!name || !/^[a-z0-9_-]+$/i.test(name)) return null;
  return svg('cda-select__icon', '<use href="#cda-i-' + name + '"></use>');
}

// Nome acessível: aria-label do select ou o texto do <label> associado.
function accessibleName(select) {
  var name = select.getAttribute('aria-label');
  if (name) return name;
  var label = select.labels && select.labels[0];
  if (!label) return '';
  var clone = label.cloneNode(true);
  Array.prototype.forEach.call(clone.querySelectorAll('select, .cda-select'), function(el) { el.remove(); });
  return clone.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '');
}

function isDisabled(state, index) {
  var option = state.select.options[index];
  return !option || option.disabled;
}

function step(state, from, delta) {
  var count = state.items.length;
  var index = from;
  for (var i = 0; i < count; i++) {
    index = Math.min(count - 1, Math.max(0, index + delta));
    if (!isDisabled(state, index)) return index;
    if (index === 0 || index === count - 1) break;
  }
  return from;
}

function renderTrigger(state) {
  var select = state.select;
  var option = select.options[select.selectedIndex];
  var text = option ? option.text : '';

  state.value.textContent = text;
  if (state.icon) state.icon.remove();
  state.icon = iconFor(option);
  if (state.icon) state.trigger.insertBefore(state.icon, state.value);

  if (state.name) state.trigger.setAttribute('aria-label', state.name + ': ' + text);

  state.items.forEach(function(item, index) {
    item.setAttribute('aria-selected', index === select.selectedIndex ? 'true' : 'false');
  });
}

function setActive(state, index) {
  state.active = index;
  state.items.forEach(function(item, i) {
    item.classList.toggle('is-active', i === index);
  });

  var item = state.items[index];
  if (!item) {
    state.trigger.removeAttribute('aria-activedescendant');
    return;
  }
  state.trigger.setAttribute('aria-activedescendant', item.id);

  // Rola só a lista (scrollIntoView rolaria a página inteira).
  var list = state.list;
  if (item.offsetTop < list.scrollTop) {
    list.scrollTop = item.offsetTop;
  } else if (item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) {
    list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;
  }
}

function open(state) {
  if (openState && openState !== state) close(openState);
  openState = state;

  state.list.hidden = false;
  state.wrapper.classList.add('is-open');
  state.trigger.setAttribute('aria-expanded', 'true');

  // Abre para cima quando não cabe embaixo.
  state.wrapper.classList.remove('is-up');
  var rect = state.trigger.getBoundingClientRect();
  var below = window.innerHeight - rect.bottom;
  if (below < state.list.offsetHeight + 12 && rect.top > below) {
    state.wrapper.classList.add('is-up');
  }

  setActive(state, Math.max(0, state.select.selectedIndex));
}

function close(state) {
  if (openState === state) openState = null;
  state.list.hidden = true;
  state.wrapper.classList.remove('is-open', 'is-up');
  state.trigger.setAttribute('aria-expanded', 'false');
  setActive(state, -1);
}

function choose(state, index) {
  if (isDisabled(state, index)) return;
  var select = state.select;
  if (select.selectedIndex !== index) {
    select.selectedIndex = index;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  renderTrigger(state);
  close(state);
  state.trigger.focus();
}

function typeahead(state, char) {
  window.clearTimeout(state.typeTimer);
  state.typed = (state.typed || '') + char.toLowerCase();
  state.typeTimer = window.setTimeout(function() { state.typed = ''; }, TYPEAHEAD_DELAY);

  var options = state.select.options;
  var start = state.typed.length === 1 ? state.active + 1 : Math.max(state.active, 0);
  for (var i = 0; i < options.length; i++) {
    var index = (start + i) % options.length;
    if (!options[index].disabled && options[index].text.toLowerCase().indexOf(state.typed) === 0) {
      setActive(state, index);
      return;
    }
  }
}

function onKeydown(state, event) {
  var isOpen = !state.list.hidden;
  var key = event.key;

  if (!isOpen) {
    if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter' || key === ' ') {
      event.preventDefault();
      open(state);
    } else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
      open(state);
      typeahead(state, key);
    }
    return;
  }

  switch (key) {
    case 'ArrowDown':
      event.preventDefault();
      setActive(state, step(state, state.active, 1));
      break;
    case 'ArrowUp':
      event.preventDefault();
      setActive(state, step(state, state.active, -1));
      break;
    case 'Home':
      event.preventDefault();
      setActive(state, step(state, -1, 1));
      break;
    case 'End':
      event.preventDefault();
      setActive(state, step(state, state.items.length, -1));
      break;
    case 'Enter':
      event.preventDefault();
      choose(state, state.active);
      break;
    case ' ':
      event.preventDefault();
      if (state.typed) typeahead(state, key);
      else choose(state, state.active);
      break;
    case 'Escape':
    case 'Esc':
      event.preventDefault();
      event.stopPropagation();
      close(state);
      break;
    case 'Tab':
      choose(state, state.active);
      break;
    default:
      if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) typeahead(state, key);
  }
}

function enhance(select) {
  var wrapper = select.parentNode;
  if (!wrapper.classList || !wrapper.classList.contains('cda-select')) {
    wrapper = document.createElement('span');
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
  }

  // O snapshot do Turbolinks volta com a UI montada, mas sem listeners: refaz tudo.
  Array.prototype.forEach.call(wrapper.querySelectorAll('.cda-select__trigger, .cda-select__list'), function(el) {
    el.remove();
  });

  var variant = select.getAttribute('data-cda-select');
  wrapper.className = 'cda-select' + (variant && variant !== 'true' ? ' cda-select--' + variant : '');

  select.classList.add('cda-select__native');
  select.setAttribute('tabindex', '-1');
  select.setAttribute('aria-hidden', 'true');

  var id = 'cda-select-' + (++uid);
  var name = accessibleName(select);

  var trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'cda-select__trigger';
  trigger.setAttribute('role', 'combobox');
  trigger.setAttribute('aria-haspopup', 'listbox');
  trigger.setAttribute('aria-expanded', 'false');
  trigger.setAttribute('aria-controls', id + '-list');
  if (select.disabled) trigger.disabled = true;

  var value = document.createElement('span');
  value.className = 'cda-select__value';
  trigger.appendChild(value);
  trigger.appendChild(svg('cda-select__chevron', CHEVRON_PATH));

  var list = document.createElement('ul');
  list.className = 'cda-select__list';
  list.id = id + '-list';
  list.setAttribute('role', 'listbox');
  list.setAttribute('tabindex', '-1');
  if (name) list.setAttribute('aria-label', name);
  list.hidden = true;

  var items = Array.prototype.map.call(select.options, function(option, index) {
    var item = document.createElement('li');
    item.id = id + '-opt-' + index;
    item.className = 'cda-select__option';
    item.setAttribute('role', 'option');
    item.setAttribute('data-index', index);
    if (option.disabled) item.setAttribute('aria-disabled', 'true');

    var icon = iconFor(option);
    if (icon) item.appendChild(icon);
    var text = document.createElement('span');
    text.className = 'cda-select__option-text';
    text.textContent = option.text;
    item.appendChild(text);
    item.appendChild(svg('cda-select__check', CHECK_PATH));

    list.appendChild(item);
    return item;
  });

  wrapper.appendChild(trigger);
  wrapper.appendChild(list);

  var state = {
    select: select, wrapper: wrapper, trigger: trigger, list: list,
    value: value, icon: null, items: items, name: name, active: -1
  };

  renderTrigger(state);

  trigger.addEventListener('click', function() {
    if (list.hidden) open(state); else close(state);
  });
  trigger.addEventListener('keydown', function(event) { onKeydown(state, event); });

  // mousedown não tira o foco do botão (o foco fica no combobox o tempo todo)
  list.addEventListener('mousedown', function(event) { event.preventDefault(); });
  list.addEventListener('click', function(event) {
    var item = event.target.closest('.cda-select__option');
    if (item) choose(state, Number(item.getAttribute('data-index')));
  });
  list.addEventListener('mousemove', function(event) {
    var item = event.target.closest('.cda-select__option');
    if (item && Number(item.getAttribute('data-index')) !== state.active) {
      setActive(state, Number(item.getAttribute('data-index')));
    }
  });

  // Valor trocado por código (select.value = ...; dispara change) também atualiza o botão.
  select.addEventListener('change', function() { renderTrigger(state); });

  // Clicar no texto do <label> abre o dropdown em vez de focar o select escondido.
  Array.prototype.forEach.call(select.labels || [], function(label) {
    label.addEventListener('click', function(event) {
      if (trigger.contains(event.target) || list.contains(event.target)) return;
      event.preventDefault();
      trigger.focus();
    });
  });

  return state;
}

function enhanceAll(root) {
  Array.prototype.forEach.call((root || document).querySelectorAll('select[data-cda-select]'), enhance);
}

// Listeners globais: registrados uma vez só (o document sobrevive às visitas do Turbolinks).
document.addEventListener('mousedown', function(event) {
  if (openState && !openState.wrapper.contains(event.target)) close(openState);
});

document.addEventListener('turbolinks:before-cache', function() {
  if (openState) close(openState);
});

document.addEventListener('turbolinks:load', function() {
  openState = null;
  enhanceAll();
});

window.cdaSelect = { enhance: enhanceAll, refresh: enhance };
